import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#3B6B9B',
          light: '#6A9ACB',
          dark: '#1A4170',
        },
        secondary: {
          main: '#4D6378',
          light: '#7A91A8',
          dark: '#24384D',
        },
        background: {
          default: '#F0F4FA',
          paper: '#FFFFFF',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: '#90C0F0',
          light: '#BCD8F8',
          dark: '#4E88C0',
        },
        secondary: {
          main: '#B0C4D8',
          light: '#CEE0F0',
          dark: '#728EA8',
        },
        background: {
          default: '#181C22',
          paper: '#2A2E36',
        },
      },
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 400 },
    h2: { fontWeight: 400 },
    h3: { fontWeight: 400 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
